import React from 'react';
import { SunIcon, MoonIcon } from 'lucide-react';
interface ThemeToggleProps {
  theme: string;
  toggleTheme: () => void;
}
export function ThemeToggle({
  theme,
  toggleTheme
}: ThemeToggleProps) {
  return <div className="flex items-center gap-2" data-id="element-165">
      <SunIcon className="h-5 w-5" data-id="element-166" />
      <button onClick={toggleTheme} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${theme === 'dark' ? 'bg-yellow-500' : 'bg-gray-300'}`} data-id="element-167">
        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${theme === 'dark' ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-168" />
      </button>
      <MoonIcon className="h-5 w-5" data-id="element-169" />
    </div>;
}